import type { ComponentProps } from 'react';

import CircleButton from '../circle-button/circle-button';

import Times from '../../../assets/icons/times.svg';

const CloseButton = (
  props: Omit<ComponentProps<typeof CircleButton>, 'children'>,
) => (
  // @ts-ignore
  <CircleButton {...props} data-testid="close-modal">
    <Times />
  </CircleButton>
);

export default CloseButton;
